import CanSidebarSection from "../../../../../../app/pannels/candidate/sections/common/can-sidebar";
function SectionCandidateAbout1() {
    return (
        <>
            <h4 className="twm-s-title">About Me</h4>
            <CanSidebarSection />
            <p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? </p>
            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi.</p>
        </>
    )
}

export default SectionCandidateAbout1;